module.exports = __webpack_public_path__ + "media/images/cart/about-takumen-ea8bd291d9e98886c761cd12fae14ebf.png";